import * as React from "react";
import { renderSportIcon } from "../../EventCard";
export const renderGameStateWrapper = (event, componentPrefix, isDesktop) => isDesktop &&
    React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__clock`, "data-uat": `div-ev-list-${componentPrefix}-clock` }, renderSportIcon(event.sportId, componentPrefix));
//# sourceMappingURL=renderGameStateWrapper.js.map